namespace Matrix.Data {

    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class SecurityRelationshipsDialog extends Serenity.TemplatedDialog<any> {

        public grid: SecurityRelationshipGrid;

        constructor() {
            super();

            this.grid = new SecurityRelationshipGrid(this.element.children());
        }

        protected getTemplate() {
            return "<div style='height: 100%; flex: 1 1 100%;'></div>";
        }
    }
}